<template>
  <h1>403</h1>
</template>

<script>
  export default {
    name: "Forbidden",
    metaInfo: {
      titleTemplate: '%s - Forbidden'
    },
  }
</script>
